/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MdEmail, MdKeyboardArrowRight } from "react-icons/md";
import { FaChrome } from "react-icons/fa";
import { BiUser } from "react-icons/bi";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@repo/ui";
import {
  useAddNotes,
  useGetTicketDetails,
  useSelfAssignTicket,
  useUpdateTicket,
  useVerifyBankReference,
} from "services/tickets";
import sweetAlert from "components/sweet-alert";
import FormInput from "ui/Input";
import FormSelect from "ui/select";
import {
  useLookupAllAssignmentGroups,
  useLookupCategories,
  useLookupCustomers,
  useLookupSubCategories,
} from "services/lookups";
import { useGetLocationDetails } from "services/service-points";
import { useGetCustomerDetails } from "services/customers";
import { FormDropdown } from "ui/combo-box";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import { useUser } from "hooks/use-user";
import {
  CREATION_CHANNELS,
  emptyTicket,
  PRIORITIES_LIST,
  StatusContext,
  TOGGLE,
} from "../constants";
import {
  disableTicketEditing,
  useGetParentTicketList,
  isCallCenterAgent,
} from "../utils";
import CustomerDetails from "../common/customer-details";
import LocationDetails from "../common/location-details";
import TicketsByLocation from "../common/tickets-by-location";
import ResolutionNotes from "components/tickets/resolution-notes";

const statusProgress = [
  { text: "New", value: "Open" },
  { text: "Assigned", value: "Assigned" },
  { text: "In Progress", value: "In Progress" },
  { text: "On Hold", value: "On Hold" },
  { text: "Resolved", value: "Resolved" },
  { text: "Closed", value: "Closed" },
];
export default function UnusualEventsDetails({ ticketData }) {
  const [ticketDetails, setTicketDetails] = useState({});
  const [allAssignmentGroups, setAllAssignmentGroups] = useState([]);
  const params = useParams();
  const { status } = useContext(StatusContext);

  const navigate = useNavigate();
  const user = useUser();
  const isCCA = isCallCenterAgent(user);
  const isCSMAgent = user.Roles.includes("CSM Agent");
  const {
    mutate: getCustomersList,
    data: customersListRes,
    isPending: gettingCustomersList,
  } = useLookupCustomers();

  const {
    mutate: getCategories,
    data: categoriesRes,
    isPending: gettingCategories,
  } = useLookupCategories();
  const {
    mutate: getSubCategories,
    data: subCategoriesRes,
    isPending: gettingSubCategories,
  } = useLookupSubCategories();

  const {
    mutate: getAllAssignmentGroups,
    data: allAssignmentGroupRes,
    isPending: gettingAllAssignmentGroup,
    reset: resetAllAssignmentGroups,
  } = useLookupAllAssignmentGroups();
  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicketDetails,
    reset: resetDetailsApi,
  } = useGetTicketDetails();

  const {
    mutate: createTicket,
    data: editTicketRes,
    isPending: creatingTicket,
  } = useUpdateTicket();
  const {
    mutate: addTicketNotes,
    data: addNotesResponse,
    isPending: addingNotes,
    error: addNotesError,
    reset: resetNotesRequest,
  } = useAddNotes();
  const {
    mutate: selfAssign,
    data: selfAssignRes,
    isPending: selfAssigning,
  } = useSelfAssignTicket();
  const {
    mutate: getCustomerDetails,
    data: customerDetailsRes,
    error: customerDetailsError,
  } = useGetCustomerDetails();
  const {
    mutate: getAssetDetails,
    data: assetDetailsRes,
    error: assetDetailsError,
  } = useGetLocationDetails();

  const {
    mutate: verifyReference,
    data: referenceVerified,
    reset: resetReferenceVerification,
  } = useVerifyBankReference();

  const form = useForm({
    defaultValues: { ...emptyTicket },
  });

  const verificationRules = {
    activityType: { required: "Please Enter Value" },
    category: { required: "Please Enter Value" },
    subCategory: { required: "Please Enter Value" },
  };
  useEffect(() => {
    getCustomersList();

    getAllAssignmentGroups();
    updateTicketDetails(ticketData);
  }, []);

  const getHomeURL = useGetParentTicketList(
    status,
    !ticketDetails.isServiceTicket
  );
  useEffect(() => {
    if (editTicketRes || selfAssignRes) {
      navigate(getHomeURL);
    }

    if (ticketDetailsRes && customersListRes) {
      if (ticketDetailsRes.status === 200) {
        updateTicketDetails(ticketDetailsRes);
      }
    }
    if (addNotesResponse) {
      if (addNotesResponse.status === 200) {
        resetNotesRequest();
        form.resetField("notesRemarks");
        form.resetField("notesAdditionalRemarks");
        getTicket(params.ticketId);
      }
    }
    if (addNotesError) {
      resetNotesRequest();
    }

    if (referenceVerified) {
      if (referenceVerified.status === 200) {
        sweetAlert({
          title: "Duplicate Reference",
          text: "Duplicate bank reference number exist in another ticket",
          icon: "warning",
        });
        resetReferenceVerification();
      }
    }
    if (allAssignmentGroupRes) {
      setAllAssignmentGroups(
        (allAssignmentGroupRes?.data || []).filter((elm) => {
          if (
            [
              "Call Center",
              "Cash Admin",
              "Planning & Analysis",
              "Security & Compliance",
              "CMC Operations-Dubai",
              "EK Outsource",
              "Fleet Management",
              "Business Development",
              "CMC Operations-Abu Dhabi",
              "TG Cash Customer Service",
            ].includes(elm.name)
          ) {
            return true;
          }
          return false;
        })
      );
      resetAllAssignmentGroups();
    }
  }, [
    editTicketRes,
    ticketDetailsRes,
    addNotesResponse,
    addNotesError,
    customersListRes,
    referenceVerified,
    allAssignmentGroupRes,
    selfAssignRes,
  ]);

  const updateTicketDetails = (ticket) => {
    const _details = {
      ...ticket,
      billingCharges: ticket.billingCharges ? "Yes" : "No",
      isCustomerComplaint: ticket.isCustomerComplaint ? "Yes" : "No",
      isChargeable: false,
      vaultAccessRequired: ticket.vaultAccessRequired ? "Yes" : "No",
      additionalRemarks: "",
    };
    form.reset(_details);

    if (ticket.activityType) {
      getCategories(ticket.activityType);
    }
    if (_details.customerId) {
      getCustomerDetails(_details.customerId);
    }
    if (_details.assetId) {
      getAssetDetails(_details.assetId);
    }

    setTicketDetails({ ..._details });
    resetDetailsApi();
  };
  const generalProps = { errors: form.formState.errors, control: form.control };
  useEffect(() => {
    if (form.watch("category")) {
      getSubCategories({
        activityType: form.getValues("activityType"),
        category: form.watch("category"),
      });
    }
  }, [form.watch("category")]);
  const onReset = () => {
    form.reset({ ...ticketDetails });
  };

  const onSelfAssign = () => {
    selfAssign(ticketDetails.ticketId);
  };
  const onSave = () => {
    const _data = form.getValues();
    const payload = {
      ticketId: _data.ticketId,
      activityType: _data.activityType,
      category: _data.category,
      subCategory: _data.subCategory,
      vaultAccessRequired: _data.vaultAccessRequired === "Yes",
      remarks: _data.updatedRemarks || "",
      additionalRemarks: _data.additionalRemarks || "",
      bankReferenceNo: _data.customerTicketNo,
      assignmentGroup: _data.assignmentGroup || "",
    };
    createTicket(payload);
  };

  const addNotes = () => {
    const payload = {
      remarks: form.getValues("notesRemarks"),
      additionalRemarks: form.getValues("notesAdditionalRemarks"),
      ticketId: form.getValues("ticketId"),
    };
    addTicketNotes(payload);
  };

  const onCategoryChange = () => {
    form.setValue("vaultAccessRequired", "No");
    form.setValue("subCategory", "");
  };
  const onSubCategoryChange = (data) => {
    const subCategory = subCategoriesRes?.data.find(
      (elm) => elm.description === data
    );
    if (subCategory) {
      if (subCategory.vaultAccessRequired) {
        form.setValue("vaultAccessRequired", "Yes");
        return;
      }
    }
    form.setValue("vaultAccessRequired", "No");
  };
  function AccountDetails() {
    if (customerDetailsError && customerDetailsError.status === 403) {
      return <>User does not have permission to view this resource</>;
    }
    if (!form.watch("customerId") || !customerDetailsRes) {
      return <>Select Account To Show Data</>;
    }

    return <CustomerDetails customer={customerDetailsRes.data} />;
  }

  function AssetDetails() {
    if (assetDetailsError && assetDetailsError.status === 403) {
      return <>User does not have permission to view this resource</>;
    }
    if (!form.watch("assetId") || !assetDetailsRes) {
      return <>Select Asset To Show Data</>;
    }

    return <LocationDetails location={assetDetailsRes.data} />;
  }
  function AccountRecords() {
    if (!form.watch("assetId")) {
      return <>Select Asset To Show Data</>;
    }

    return <TicketsByLocation servicePointId={form.watch("assetId")} />;
  }

  const isFormDisabled = useMemo(() => {
    const status = form.watch("status");
    return disableTicketEditing(status);
  }, [form.watch("status")]);

  const creationChannel = useMemo(() => {
    return form.watch("creationChannel");
  }, [form.watch("creationChannel")]);
  function StatusIcon() {
    if (creationChannel === "Web") {
      return (
        <FaChrome className="text-secondary cursor-pointer" fontSize="20px" />
      );
    } else if (creationChannel === "Customer Portal") {
      return (
        <BiUser className="text-secondary cursor-pointer" fontSize="20px" />
      );
    } else if (creationChannel === "Auto Email") {
      return (
        <MdEmail className="text-secondary cursor-pointer" fontSize="20px" />
      );
    }
  }
  return (
    <>
      {gettingCustomersList ||
      creatingTicket ||
      gettingCategories ||
      addingNotes ||
      gettingTicketDetails ||
      gettingSubCategories ||
      selfAssigning ||
      gettingAllAssignmentGroup ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <Breadcrumb className="mt-5 text-black">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink>
                <Link to={getHomeURL} className="text-black">
                  Tickets
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-black" />

            <BreadcrumbItem>
              <BreadcrumbPage className="text-black">
                {form.watch("caseNo") || "Case Number"}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <div className="flex flex-row justify-end w-full gap-2 items-center">
          <div
            title={`Source: ${form.watch("creationChannel")}`}
            style={{ background: "white" }}
          >
            <div>
              <StatusIcon />
            </div>
          </div>
          <Button
            variant="secondary"
            disabled={!form.formState.isDirty}
            onClick={form.handleSubmit(onSave)}
            type="submit"
          >
            Update
          </Button>

          <Button variant="secondary" onClick={onSelfAssign} type="button">
            Self Assign
          </Button>

          <Button
            variant="secondary"
            disabled={isFormDisabled}
            onClick={onReset}
          >
            Reset
          </Button>

          <Button
            variant="secondary"
            onClick={() => {
              navigate(getHomeURL);
            }}
          >
            Home
          </Button>

          {/* <UpdateStatus
            requestDetails={form.getValues()}
            onReload={() => {
              getTicket(params.ticketId);
            }}
            triggerButton={
              <Button variant={"secondary"} type={"submit"}>
                Update Status
              </Button>
            }
          /> */}
        </div>
        <Card
          className="form-card shadow-none rounded-lg mx-0 "
          style={{ padding: "12px 2rem" }}
        >
          <div className="flex flex-row w-full justify-between items-center my-2">
            {statusProgress.map((elm, index) => (
              <>
                {index === 0 ? <></> : <MdKeyboardArrowRight fontSize="20" />}
                <div className="flex flex-col items-center justify-center gap-1">
                  <div
                    key={index}
                    className={
                      elm.value === form.getValues("status")
                        ? "w-4 h-4 rounded-[50%] border border-solid border-1 border-secondary bg-secondary"
                        : "w-4 h-4 rounded-[50%]  border border-solid border-1  border-secondary bg-white"
                    }
                  />
                  <p>{elm.text}</p>
                </div>
              </>
            ))}
          </div>
        </Card>
        <Card className="form-card shadow-lg mx-0 pb-20">
          <CardHeader>
            <CardTitle>Unusual Event Details</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form className="space-y-8 custom-form-v2">
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    name="alertDateTime"
                    label="Alert Date Time"
                    disabled
                    hideIcons
                  />
                </div>
                <div className="form-row-d-50">
                  {/* <FormInput
                  {...generalProps}
                  isRequired={true}
                  name={"customerId"}
                  label={"Customer Id"}
                  rules={verificationRules.customerId}
                /> */}
                  <FormInput
                    {...generalProps}
                    name="caseNo"
                    label="TG Reference Number"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="createDateTime"
                    label="Created"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="reportedBy"
                    label="Reported By"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="createdBy"
                    label="Created By"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="customerTicketNo"
                    label="Address"
                    disabled={
                      !isCCA ||
                      isCSMAgent ||
                      (ticketDetails?.customerTicketNo &&
                        ticketDetails.status === "Closed")
                    }
                    onBlur={() => {
                      if (
                        !ticketDetails.customerTicketNo &&
                        form.watch("customerTicketNo")
                      )
                        verifyReference(form.watch("customerTicketNo"));
                    }}
                    rules={{
                      pattern: {
                        value: /^[A-Za-z0-9\s]+$/,
                        message: "Invalid Pattern(Only Alphanumeric Allowed)",
                      },
                    }}
                  />
                  <FormInput
                    {...generalProps}
                    name="status"
                    label="State"
                    disabled
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Account"
                    name="customerId"
                    data={customersListRes?.data || []}
                    text="name"
                    id="customerId"
                    placeholder="Select Customer"
                    // rules={verificationRules.customerId}
                    disabled
                    detailsView={<AccountDetails />}
                  />
                  <FormInput
                    {...generalProps}
                    name="state"
                    label="Region"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="locationId"
                    label="Asset ID"
                    disabled
                    detailsView={
                      ticketDetails.assetId ? <AssetDetails /> : null
                    }
                    recordsView={
                      ticketDetails.assetId ? <AccountRecords /> : null
                    }
                    recordContentClass="max-w-[1000px]"
                  />
                  <FormInput
                    {...generalProps}
                    name="locationName"
                    label="Location"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    label="Activity Type"
                    name="activityType"
                    disabled
                    isRequired
                  />
                  <FormSelect
                    {...generalProps}
                    name="creationChannel"
                    label="Creation Channel"
                    placeholder="Select Creation Channel"
                    data={CREATION_CHANNELS}
                    id="id"
                    text="text"
                    disabled
                  />

                  <FormDropdown
                    {...generalProps}
                    isRequired
                    label="Category"
                    name="category"
                    disabled={!isCCA || isFormDisabled || isCSMAgent}
                    placeholder="Select Category"
                    data={categoriesRes?.data || []}
                    text="description"
                    id="description"
                    rules={verificationRules.category}
                    onChange={onCategoryChange}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Assignment Group"
                    name="assignmentGroup"
                    disabled={!isCCA || isFormDisabled || isCSMAgent}
                    placeholder="Select Assignment Group"
                    data={allAssignmentGroups || []}
                    text="name"
                    id="name"
                    // rules={verificationRules.assignmentGroup}
                    info={
                      form.watch("assetId") && form.watch("activityType")
                        ? ""
                        : "Select Asset & Activity Type To Load Data"
                    }
                  />
                  <FormDropdown
                    {...generalProps}
                    isRequired
                    label="Sub Category"
                    name="subCategory"
                    placeholder="Select Sub Category"
                    rules={verificationRules.subCategory}
                    disabled={!isCCA || isFormDisabled || isCSMAgent}
                    data={subCategoriesRes?.data || []}
                    text="description"
                    id="description"
                    onChange={onSubCategoryChange}
                    info={
                      form.watch("category")
                        ? ""
                        : "Select Category To Load Data"
                    }
                  />
                  <FormInput
                    {...generalProps}
                    name="auditedBy"
                    label="Audited By"
                    disabled
                  />

                  <FormSelect
                    {...generalProps}
                    name="priority"
                    label="Priority"
                    placeholder="Select Priority"
                    data={PRIORITIES_LIST}
                    id="id"
                    disabled
                    text="text"
                  />

                  <FormSelect
                    {...generalProps}
                    name="isCustomerComplaint"
                    label="Customer Complaint"
                    placeholder="Select Is Customer Complaint"
                    data={TOGGLE}
                    id="text"
                    disabled
                    text="text"
                  />
                  <FormInput
                    {...generalProps}
                    name="assignedTo"
                    label="Assigned To"
                    disabled
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    // rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Description"
                            style={{ justifyContent: "start" }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                disabled
                                {...field}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="updatedRemarks"
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Remarks"
                            style={{ justifyContent: "start" }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                disabled={
                                  !isCCA ||
                                  isCSMAgent ||
                                  (isFormDisabled &&
                                    ticketDetails.status !== "Cancelled")
                                }
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="additionalRemarks"
                    // rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Additional Remarks"
                            style={{
                              justifyContent: "start",
                              textAlign: "left",
                              width: "100%",
                              textWrap: "nowrap",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                disabled={
                                  !isCCA ||
                                  isCSMAgent ||
                                  isFormDisabled ||
                                  form.watch("In Progress") ||
                                  form.watch("Resolved") ||
                                  form.watch("Awaiting Customer Approval") ||
                                  form.watch("Awaiting Re-Opening")
                                }
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.additionalRemarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.additionalRemarks ? (
                              <p className="text-destructive text-xs">
                                {
                                  form.formState.errors.additionalRemarks
                                    .message
                                }
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>

                <Tabs
                  defaultValue="resolutionNotes"
                  className="w-full form-container-tabs"
                  variant="secondary"
                >
                  <TabsList
                    className="w-full justify-start"
                    style={{ justifyContent: "flex-start" }}
                  >
                    <TabsTrigger value="notes">Notes</TabsTrigger>
                    <TabsTrigger
                      value="resolutionNotes"
                      disabled={
                        ticketDetails.status === "Cancelled" ||
                        ticketDetails.status === "Closed"
                      }
                    >
                      Resolution Notes
                    </TabsTrigger>
                    <TabsTrigger value="information">
                      Additional Information
                    </TabsTrigger>
                    <TabsTrigger value="requestDetails">
                      Request Details
                    </TabsTrigger>
                    <TabsTrigger value="accessTiming">
                      Access Timings
                    </TabsTrigger>
                    <TabsTrigger value="denomination">Denomination</TabsTrigger>
                    <TabsTrigger value="resolutionInformation">
                      Resolution Information
                    </TabsTrigger>
                    <TabsTrigger value="System">system</TabsTrigger>
                  </TabsList>

                  <TabsContent value="notes">
                    {form.watch("status") !== "Closed" &&
                    form.watch("status") !== "Cancelled" ? (
                      <>
                        {isCCA ? (
                          <>
                            <FormField
                              control={form.control}
                              name="notesRemarks"
                              render={({ field }) => (
                                <FormItem>
                                  <Label label="Work Notes" />

                                  <FormControl>
                                    <Textarea
                                      {...field}
                                      className="border-secondary"
                                      style={{ marginBottom: "16px" }}
                                    />
                                  </FormControl>
                                </FormItem>
                              )}
                            />
                            <FormField
                              control={form.control}
                              name="notesAdditionalRemarks"
                              render={({ field }) => (
                                <FormItem>
                                  <Label label="Additional Comments" />
                                  <FormControl>
                                    <Textarea
                                      {...field}
                                      className="border-secondary mb-4"
                                      style={{ marginBottom: "16px" }}
                                    />
                                  </FormControl>
                                </FormItem>
                              )}
                            />

                            <div className="flex flex-row w-full justify-end">
                              <Button variant="secondary" onClick={addNotes}>
                                Post
                              </Button>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <></>
                    )}

                    {form.watch("logs")?.map((elm, index) => {
                      return (
                        <Card
                          className="px-2 py-4 my-2 shadow-none rounded-lg  justify-between flex flex-row gap-8"
                          key={index}
                        >
                          <div className="flex flex-col gap-2 max-w-[70%]">
                            <p className="font-medium text-md">
                              Action: {elm.operation}
                            </p>

                            <p className="font-normal text-md">
                              <span className="font-medium"> Notes: </span>
                              {elm.remarks}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium">Comments: </span>
                              {elm.additionalRemarks}
                            </p>
                          </div>
                          <div className="flex flex-col gap-2">
                            <p className="font-normal text-md">
                              <span className="font-medium">Updated By:</span>
                              &nbsp;
                              {elm.user}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium"> Updated At: </span>
                              {elm.operationTime}
                            </p>
                          </div>
                        </Card>
                      );
                    })}
                  </TabsContent>

                  <TabsContent value="resolutionNotes">
                    {ticketDetails?.activityType ? (
                      <ResolutionNotes
                        requestId={ticketDetails.ticketId}
                        ticket={ticketDetails}
                        ticketView
                      />
                    ) : (
                      <></>
                    )}
                  </TabsContent>
                  <TabsContent value="information" />
                  <TabsContent value="requestDetails">Coming Soon</TabsContent>
                  <TabsContent value="accessTiming">Coming Soon</TabsContent>
                  <TabsContent value="denomination">Coming Soon</TabsContent>
                  <TabsContent value="resolutionInformation">
                    Coming Soon
                  </TabsContent>
                  <TabsContent value="system">Coming Soon</TabsContent>
                </Tabs>
              </CardContent>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
